import React from 'react'
import { connect } from 'react-redux'
import { doGetPrinterList} from '../../reducers/actions'
import PrinterPortDiv from './PrinterPortDiv'

class PrinterListDiv extends React.Component {
  state = {}
  componentDidMount = () => {
    this.handleInitPrinter()
  }
  handleInitPrinter = () => {
    const { onSave, onClose, dispatch } = this.props
    dispatch(doGetPrinterList({
      onEnd: ({ errorMessage, initValues基本信息 }) => {
        if (errorMessage) {
          Tyan.pubForm.showError(errorMessage)
        }
        else if (initValues基本信息) {
          this.setState({ initValues基本信息 })
        }
      }
    }))
  }
  handleAddPrinter = (data) => {
    Tyan.pubForm.showDialog('打印机设置', props => <PrinterPortDiv {...props} id={-1} onSave={this.handleInitPrinter} />)
    this.setState({})
  }

  handleEditPrinter = (data) => {
    Tyan.pubForm.showDialog('打印机设置', props => <PrinterPortDiv {...props} id={data.id} onSave={this.handleInitPrinter} />)
    this.setState({})
  }

  handlerClose = () => {
    const { onClose } = this.props
    onClose && onClose()
  }

  fieldset模板 = () => {
    return [{
      _grid: '', name: '打印机', rowNumbers: true, minRows: 5,
      columns: [
        { _text: '名称', name: '打印机名称', minWidth: 200, flex: 1 },
        { _text: '地址', name: '地址', minWidth: 300, flex: 1 },
        { _text: '精度', name: '精度', minWidth: 100, flex: 1 },
      ],
      onDoubleTap: this.handleEditPrinter,
    }]
  }

  render = () => {
    const { showBody: Body } = this.props

    return <Body data={this} maxWidth={1200}
      controls={
        [
          { _button: '添加', handler: this.handleAddPrinter },
          { _button: '关闭', handler: this.handlerClose },
        ]}
      fieldsets={[
        { title: '', name: '基本信息', _fieldset: this.fieldset模板(), flex: 1 },
      ]}
    />
  }
}

export default connect()(PrinterListDiv)